/**
 * live/score-points.ts — helper di visualizzazione match/set point (portato
 * da `/opt/ws-dinamolfetta/src/lib/volleyball/score-logic.ts`, solo le due
 * funzioni di display usate da `ScorePanel`).
 *
 * Regole FIPAV: set a 25 (+2), 5° set (tiebreak) a 15 (+2), partita a 3 set.
 */
import type { MatchState } from './state'

const SET_WIN_SCORE = 25
const TIEBREAK_WIN_SCORE = 15
const MIN_ADVANTAGE = 2
const MAX_SETS = 5
const SETS_TO_WIN_MATCH = 3

function isTiebreakSet(setNumber: number): boolean {
  return setNumber === MAX_SETS
}

function winScore(setNumber: number): number {
  return isTiebreakSet(setNumber) ? TIEBREAK_WIN_SCORE : SET_WIN_SCORE
}

/**
 * Regola FIPAV del set: 25 punti (15 al tiebreak) con almeno 2 di scarto.
 * Unica implementazione: la usano sia il display (`isSetPoint`) sia il
 * reducer (`closeSet`), così la soglia non può divergere fra UI e server.
 */
export function isSetWon(teamScore: number, opponentScore: number, setNumber: number): boolean {
  const target = winScore(setNumber)
  return teamScore >= target && teamScore - opponentScore >= MIN_ADVANTAGE
}

/** True se, segnando un altro punto, la squadra vince la PARTITA (match point). */
export function isMatchPoint(state: MatchState, team: 'home' | 'away'): boolean {
  if (state.isMatchFinished) return false
  const opTeam = team === 'home' ? 'away' : 'home'
  if (SETS_TO_WIN_MATCH - state.setsWon[team] > 1) return false
  return isSetWon(state.currentScore[team] + 1, state.currentScore[opTeam], state.currentSet)
}

/** True se, segnando un altro punto, la squadra vince il SET (set point). */
export function isSetPoint(state: MatchState, team: 'home' | 'away'): boolean {
  if (state.isMatchFinished) return false
  const opTeam = team === 'home' ? 'away' : 'home'
  return isSetWon(state.currentScore[team] + 1, state.currentScore[opTeam], state.currentSet)
}
